var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancovanieEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7B7CD3;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,48.4l0,21.9l-4-5.9c-0.5-0.7-1.4-0.7-2-0.1c-5.4,6.3-13.4,9.4-21.6,8.7c-12.2-1.2-22-11.3-22.7-23.6 c-0.9-15.3,12-28,27.4-26.6C65.3,23.9,75.5,35.7,75.5,48.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,62.5v-2.4c-6.9-1.3-11.3-7.2-11.3-14c0-3.8,1.3-8.3,6-11.2l2.7,3.9c-2.6,1.8-3.6,4.5-3.6,7.2 c0,4,2.3,7.4,6.2,8.6v-8.2h2.7v8.5h0.2c0.4,0,0.8,0,1.1,0v-8.5h2.7v7.8c3.4-1.4,5.3-4.6,5.3-8.3c0-2.8-1.1-5.3-3.6-7.1l2.7-3.9 c4.7,2.9,6,7.4,6,11.2c0,6.6-4,12.2-10.4,13.8v2.6h-2.7v-2.2c-0.4,0-0.7,0-1.1,0h-0.2v2.1H47.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancovanieEuro);
export default __webpack_public_path__ + "static/media/financovanie_euro.82e0b677fb4d28a56c07c1b3aac3aa03.svg";
export { ForwardRef as ReactComponent };